import { InputProps } from '../OdfjellInputComponent';
import TextareaAutosize from 'react-textarea-autosize';
import React, { useState, useEffect } from 'react';
import { TextAreaContainer, TextCounter } from './TextAreaInput.style';

const TextAreaInputComponent: React.FC<Partial<InputProps>> = ({
    value,
    name,
    elementId,
    onChange,
    maxTextLength,
    tabIndex,
}: Partial<InputProps>) => {
    const [currentLength, setCurrentLength] = useState<number>(value ? String(value).length : 0);

    useEffect(() => {
        // Update character count when value changes externally
        setCurrentLength(value ? String(value).length : 0);
    }, [value]);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setCurrentLength(event.target.value.length);
        onChange({ event });
    };

    return (
        <TextAreaContainer>
            <TextareaAutosize
                name={name}
                id={elementId}
                className="input"
                hidden={false}
                value={value}
                onChange={handleChange}
                maxLength={maxTextLength ?? 3995}
                tabIndex={tabIndex}
            />
            {maxTextLength && (
                <TextCounter>
                    {currentLength}/{maxTextLength}
                </TextCounter>
            )}
        </TextAreaContainer>
    );
};

export default TextAreaInputComponent;
